(function () {
  'use strict';

  function qs(sel, ctx) { return (ctx || document).querySelector(sel); }
  function qsa(sel, ctx) { return Array.prototype.slice.call((ctx || document).querySelectorAll(sel)); }

  /* ---------------- Header: solid after scrolling (when it overlays a hero) ---------------- */
  var header = qs('[data-site-header]');
  if (header && header.classList.contains('site-header--overlay')) {
    var onScroll = function () {
      header.classList.toggle('is-scrolled', window.scrollY > 40);
    };
    onScroll();
    window.addEventListener('scroll', onScroll, { passive: true });
  }

  /* ---------------- Mobile menu: folders with a Back button ---------------- */
  var menu = qs('[data-mobile-menu]');
  if (menu) {
    var panels = qsa('[data-menu-panel]', menu);

    var showPanel = function (id) {
      panels.forEach(function (panel) {
        var name = panel.getAttribute('data-menu-panel');
        var active = name === id;
        panel.classList.toggle('is-active', active);
        panel.classList.toggle('is-left', !active && name === 'root' && id !== 'root');
      });
    };

    menu.addEventListener('click', function (e) {
      var open = e.target.closest('[data-menu-open]');
      if (open) {
        showPanel(open.getAttribute('data-menu-open'));
        return;
      }
      if (e.target.closest('[data-menu-back]')) showPanel('root');
    });

    /* lock page scroll while the menu is open, reset to the first level on close */
    new MutationObserver(function () {
      document.documentElement.style.overflow = menu.hidden ? '' : 'hidden';
      if (menu.hidden) showPanel('root');
    }).observe(menu, { attributes: true, attributeFilter: ['hidden'] });

    showPanel('root');
  }

  /* ---------------- Hide the bag bubble when the bag is empty ---------------- */
  function syncCartBubbles() {
    qsa('.cart-count').forEach(function (el) {
      el.classList.toggle('is-zero', el.textContent.trim() === '0');
    });
  }
  syncCartBubbles();
  qsa('.cart-count').forEach(function (el) {
    new MutationObserver(syncCartBubbles).observe(el, { childList: true, characterData: true, subtree: true });
  });

  /* ---------------- Collection: category dropdown navigates ---------------- */
  qsa('[data-collection-filter]').forEach(function (select) {
    select.addEventListener('change', function () {
      if (select.value) window.location.href = select.value;
    });
  });
})();